/* eslint-disable camelcase */
export default {
  operation: "Операция",
  date: "Дата",
  amount: "Сумма",
  operation_history_for: "История операций для {n1}",
  loading: 'загружается...',
  operation_type_filter: "Фильтр по типу операции",
  wallet_filter: "Фильтр по кошелькам",

  op_online_fill_up: "Пополнение онлайн",
  op_adjustment: "Коррекция",
  op_commission_payment: "Комиссионный платеж",
  op_payout: "Вывод средств",
  op_account_to_account_transfer: "Перевод между аккаунтами",
  op_account_to_account_transfer_in: "Входящий перевод между аккаунтами",
  op_account_to_account_transfer_out: "Исходящий перевод между аккаунтами",
  op_administrative_transfer: "Административный перевод",
  op_administrative_transfer_in: "Входящий административный перевод",
  op_administrative_transfer_out: "Исходящий административный перевод",
  op_purchase_order: "Оформление заказа",
  op_purchase_cancellation: "Отмена заказа",
  op_wallet_exchange: "Обмен кошельков",
  op_wallet_exchange_in: "Входящий обмен кошельков",
  op_wallet_exchange_out: "Исходящий обмен кошельков",
  op_undefined_operation: "Неизвестная операция",
};
